<template>
    <div class=" has-text-white"> 
         <div id="xButt" class="delete  top10" @click="$parent.closeRightBar"></div>

        
         <div style="position: fixed; width:415px; z-index: 2" class="">
            <div class="has-text-white is-size-4 has-background-dark pad10">
                <right-bar-switcher class="top-10"></right-bar-switcher>
                NOTIFICATIONS
            </div>
            
        </div>
        <br><br><br><br>
        <table class="top-4" width="100%">
             <div class="has-background-grey has-text-light">&nbsp;<b>Unread</b></div>
             <div v-show="newNots.length == 0">&nbsp;No unread Notifications</div>
            <div v-for="(item, i) in newNots" :key="i" class="is-size-6">
                   <!--  <tr v-if="item.kind == 'bundleUpdated'" @click="notfClick(item.kind, item.id, item.payload, item.markAsRead)" class="handCursor" :class="{notificationRead: item.markAsRead == 1, notificationProcessed: item.markAsRead == 2}">
                        <td width="5%" :class="{'has-text-coolGreen': item.markAsRead == 0, 'has-text-gray': item.markAsRead == 1}">{{item.markAsRead == 0 || item.markAsRead == 1  ? '&nbsp;&bull;' : '&nbsp;'}}</td>
                        <td width="20%" class="is-size-7">
                            <div class="top3">{{az.dateConvert(item.createDate)}}</div>
                        </td>
                        <td width="65%">
                            <b>{{item.originator}}</b> pushed bundle updates.
                        </td>
                    </tr> -->

                     <tr v-if="item.kind == 'connectRequest'" @click="notfClick(item.kind, item.id, item.payload, item.markAsRead)" class="handCursor" :class="{notificationRead: item.markAsRead == 1, notificationProcessed: item.markAsRead == 2}">
                        <td width="5%" :class="{'has-text-coolGreen': item.markAsRead == 0, 'has-text-gray': item.markAsRead == 1}">{{item.markAsRead == 0 || item.markAsRead == 1  ? '&nbsp;&bull;' : '&nbsp;'}}</td>
                        <td width="20%" class="is-size-7">
                            <div class="top3">{{az.dateConvert(item.createDate)}}</div>
                        </td>
                        <td width="65%">
                            <b>{{item.originator}}</b> wants to add you to their collab network.
                        </td>
                    </tr>

                   <!--  <tr v-if="item.kind == 'bundleShared'" @click="notfClick(item.kind, item.id, item.payload, item.markAsRead)" class="handCursor" :class="{notificationRead: item.markAsRead == 1, notificationProcessed: item.markAsRead == 2}">
                        <td width="5%" :class="{'has-text-coolGreen': item.markAsRead == 0, 'has-text-gray': item.markAsRead == 1}">{{item.markAsRead == 0 || item.markAsRead == 1  ? '&nbsp;&bull;' : '&nbsp;'}}</td>
                        <td width="20%" class="is-size-7">
                            <div class="top3">{{az.dateConvert(item.createDate)}}</div>
                        </td>
                        <td width="65%">
                            <b>{{item.originator}}</b> Shared a bundle with you.
                        </td>
                    </tr> -->

                  <!--   <tr v-if="item.kind == 'addedToGroup'" @click="notfClick(null, null, null, item.markAsRead, true )"  class="" :class="{notificationRead: item.markAsRead == 1, notificationProcessed: item.markAsRead == 3, handCursor: item.markAsRead == 3}" >
                        <td width="5%" :class="{'has-text-coolGreen': item.markAsRead == 0, 'has-text-gray': item.markAsRead == 1}">{{item.markAsRead == 0 || item.markAsRead == 1  ? '&nbsp;&bull;' : '&nbsp;'}}</td>
                        <td width="20%" class="is-size-7">
                            <div class="top3">{{az.dateConvert(item.createDate)}}</div>
                        </td>
                        <td width="65%" class="tdPad">
                            <b>{{item.originator}}</b> Added you to a group<br>
                            <div class="is-size-7-tight">You will get on of these notifications for each bundle shared in the group</div>
                            <div class="is-size-7 top10">
                                <button :disabled="item.markAsRead == 2 || item.markAsRead == 3" class="button is-coolGreen is-small" @click="notfClick('bundleShared', item.id, item.payload.split('|')[0], item.markAsRead)"><b>Import Bundle</b></button> 
                                <span v-show="item.payload.split('|')[1] != ''"> &nbsp; </span> 
                                <button :disabled="item.markAsRead == 3 || item.markAsRead == 0 || item.markAsRead == 1" v-show="item.payload.split('|')[1] != ''" class="button is-coolGreen is-small" @click="notfClick('bundleUpdated', item.id, item.payload.split('|')[1], item.markAsRead, true)"><b>Import Updates</b></button>
                            </div>
                        </td>
                    </tr> -->

                      <tr v-if="item.kind == 'userToGroup'" @click="notfClick(null, null, null, item.markAsRead, true )"  class="" :class="{notificationRead: item.markAsRead == 1, notificationProcessed: item.markAsRead == 3, handCursor: item.markAsRead == 3}" >
                        <td width="5%" :class="{'has-text-coolGreen': item.markAsRead == 0, 'has-text-gray': item.markAsRead == 1}">{{item.markAsRead == 0 || item.markAsRead == 1  ? '&nbsp;&bull;' : '&nbsp;'}}</td>
                        <td width="20%" class="is-size-7">
                            <div class="top3">{{az.dateConvert(item.createDate)}}</div>
                        </td>
                        <td width="65%" class="tdPad">
                            <b>{{item.originator}}</b> invited you to a Bundle<br>
                            <div class="is-size-7-tight">Collab bundles allow you to collaborate.</div>
                            <div class="is-size-7 top10">
                                <button :disabled="item.markAsRead == 2 || item.markAsRead == 3" class="button is-coolGreen is-small top-5" @click="notfClick('userToGroup', item.id, item.payload, item.markAsRead, null, 1)"><b>Accept</b></button> 
                                <span> &nbsp; </span> 
                                <button :disabled="item.markAsRead == 2 || item.markAsRead == 3" class="button is-coolGreen is-small top-5" @click="notfClick('userToGroup', item.id, item.payload, item.markAsRead, null, 0)"><b>Ignore</b></button>
                            </div>
                        </td>
                    </tr>


                
            </div> 

            <div v-show="oldNots.length > 0">
                <div class="has-background-grey has-text-light">&nbsp;<b>Read and Processed</b>&nbsp;
                    <button v-show="!showOld" class="button is-small xs top2 is-coolGreen" @click="showThem">SHOW</button>
                    <button v-show="showOld" class="button is-small xs top2 is-coolGreen" @click="hideThem">HIDE</button></div>
                <div v-show="showOld" v-for="(item, i) in oldNots" :key="i" class="is-size-6">
                    
                        <!-- <tr v-if="item.kind == 'bundleUpdated'" @click="notfClick(item.kind, item.id, item.payload, item.markAsRead)" class="handCursor" :class="{notificationRead: item.markAsRead == 1, notificationProcessed: item.markAsRead == 2}">
                            <td width="5%" :class="{'has-text-coolGreen': item.markAsRead == 0, 'has-text-gray': item.markAsRead == 1}">{{item.markAsRead == 0 || item.markAsRead == 1  ? '&nbsp;&bull;' : '&nbsp;'}}</td>
                            <td width="20%" class="is-size-7">
                                <div class="top3">{{az.dateConvert(item.createDate)}}</div>
                            </td>
                            <td width="65%">
                                <b>{{item.originator}}</b> pushed bundle updates.
                            </td>
                        </tr> -->
    
                         <tr v-if="item.kind == 'connectRequest'" @click="notfClick(item.kind, item.id, item.payload, item.markAsRead)" class="handCursor" :class="{notificationRead: item.markAsRead == 1, notificationProcessed: item.markAsRead == 2}">
                            <td width="5%" :class="{'has-text-coolGreen': item.markAsRead == 0, 'has-text-gray': item.markAsRead == 1}">{{item.markAsRead == 0 || item.markAsRead == 1  ? '&nbsp;&bull;' : '&nbsp;'}}</td>
                            <td width="20%" class="is-size-7">
                                <div class="top3">{{az.dateConvert(item.createDate)}}</div>
                            </td>
                            <td width="65%">
                                <b>{{item.originator}}</b> wants to add you to their their collab network.
                            </td>
                        </tr>
    
                       <!--  <tr v-if="item.kind == 'bundleShared'" @click="notfClick(item.kind, item.id, item.payload, item.markAsRead)" class="handCursor" :class="{notificationRead: item.markAsRead == 1, notificationProcessed: item.markAsRead == 2}">
                            <td width="5%" :class="{'has-text-coolGreen': item.markAsRead == 0, 'has-text-gray': item.markAsRead == 1}">{{item.markAsRead == 0 || item.markAsRead == 1  ? '&nbsp;&bull;' : '&nbsp;'}}</td>
                            <td width="20%" class="is-size-7">
                                <div class="top3">{{az.dateConvert(item.createDate)}}</div>
                            </td>
                            <td width="65%">
                                <b>{{item.originator}}</b> Shared a bundle with you.
                            </td>
                        </tr> -->
    
                       <!--  <tr v-if="item.kind == 'addedToGroup'" @click="notfClick(null, null, null, item.markAsRead, true )"  class="" :class="{notificationRead: item.markAsRead == 1, notificationProcessed: item.markAsRead == 3, handCursor: item.markAsRead == 3}" >
                            <td width="5%" :class="{'has-text-coolGreen': item.markAsRead == 0, 'has-text-gray': item.markAsRead == 1}">{{item.markAsRead == 0 || item.markAsRead == 1  ? '&nbsp;&bull;' : '&nbsp;'}}</td>
                            <td width="20%" class="is-size-7">
                                <div class="top3">{{az.dateConvert(item.createDate)}}</div>
                            </td>
                            <td width="65%" class="tdPad">
                                <b>{{item.originator}}</b> Added you to a group<br>
                                <div class="is-size-7-tight">You will get on of these notifications for each bundle shared in the group</div>
                                <div class="is-size-7 top10">
                                    <button :disabled="item.markAsRead == 2 || item.markAsRead == 3" class="button is-coolGreen is-small" @click="notfClick('bundleShared', item.id, item.payload.split('|')[0], item.markAsRead)"><b>Import Bundle</b></button> 
                                    <span v-show="item.payload.split('|')[1] != ''"> &nbsp; </span> 
                                    <button :disabled="item.markAsRead == 3 || item.markAsRead == 0 || item.markAsRead == 1" v-show="item.payload.split('|')[1] != ''" class="button is-coolGreen is-small" @click="notfClick('bundleUpdated', item.id, item.payload.split('|')[1], item.markAsRead, true)"><b>Import Updates</b></button>
                                </div>
                            </td>
                        </tr> -->

                    <tr v-if="item.kind == 'userToGroup'" @click="notfClick(null, null, null, item.markAsRead, true )"   :class="{notificationRead: item.markAsRead == 1, notificationProcessed: item.markAsRead == 2, handCursor: item.markAsRead == 3}" >
                        <td width="5%" :class="{'has-text-coolGreen': item.markAsRead == 0, 'has-text-gray': item.markAsRead == 1}">{{item.markAsRead == 0 || item.markAsRead == 1  ? '&nbsp;&bull;' : '&nbsp;'}}</td>
                        <td width="20%" class="is-size-7">
                            <div class="top3">{{az.dateConvert(item.createDate)}}</div>
                        </td>
                        <td width="65%" class="tdPad">
                            <b>{{item.originator}}</b> invited you to a Bundle<br>
                            <div class="is-size-7-tight">Collab bundles allow you to collaborate.</div>
                            <div class="is-size-7 top10">
                                <button :disabled="item.markAsRead == 2 || item.markAsRead == 3" class="button is-coolGreen is-small top-5" @click="notfClick('userToGroup', item.id, item.payload, item.markAsRead)"><b>Accept</b></button> 
                                <span> &nbsp; </span> 
                                <button :disabled="item.markAsRead == 2 || item.markAsRead == 3" class="button is-coolGreen is-small top-5" @click="notfClick('userToGroup', item.id, item.payload, item.markAsRead, null, 0)"><b>Ignore</b></button>
                            </div>
                        </td>
                    </tr>
                
    
                </div>
            </div>
        </table>
    </div>
</template>

<script>

import RightBarSwitcher from '../components/RightBarSwitcher'

export default {
    components: {
        RightBarSwitcher
    },

    data: function(){
        return {
            az: az,
            showOld: false
        }
    },
    methods: {
        getBundleName: function(p){
            var arr = JSON.parse(p)
            var b = arr[0].split('|')[1]

            for(var x=0; x < this.$root.app.bundles.length; x++){ 
                if(this.$root.app.bundles[x].origId == b){
                    return this.$root.app.bundles[x].listName
                }
            }
            return false
        },

        notfClick: function(kind, id, payload, markAsRead, byPass, acc){

            if(kind == null && byPass == true) return

            if((markAsRead == 2 && !byPass) || markAsRead == 3 ){
                this.$root.app.showModalOK({message: "You have already processed this notification."})
                return
            } 

            this.$root.app.rightBar = false

            if(kind == 'bundleUpdated'){
                this.$router.push({name: 'sb', params: {upd: true, updateId: payload, notId: id, setNotTo3: byPass ? true : false}})
            } else if(kind == 'connectRequest'){
                this.$router.push('/managerequest?id=' + payload)
            } else if(kind == 'bundleShared'){
                this.$router.push('/sb?s=' + payload + '_' + id) 
            } else if(kind == 'userToGroup'){
                this.acceptGroup(id, parseInt(payload), acc)
            }
            
        },

        acceptGroup: function(notId, recordId, acc){
            var self = this;
            function w(d){
                if(d.r == 'ok'){
                    let n = self.$root.app.nots.find(e => {
                        return e.id == notId
                    })
                    n.markAsRead = 2
                    self.$root.app.unRead -= 1
                    
                    self.$root.app.InitialDataLoad(true)
                   
                } else if(d == 'no record'){
                    self.$root.app.showModalOK({message: 'This invitation is no longer available.'})
                }
            }

            function n(){

            }

            this.$root.app.apiClient.put('subs/data/acceptcollabadd', {notId: notId, recordId: recordId, acc: acc}, w, n);
        },

        showThem: function(){
            this.showOld = true
        },
        hideThem: function(){
            this.showOld = false
        }
    },

    computed: {
        newNots: function(){
            if(this.$root.app.nots){
                return this.$root.app.nots.filter(e => {
                    return e.markAsRead == 0
                })
            }
            return []
        },

        oldNots: function(){
            if(this.$root.app.nots){
                return this.$root.app.nots.filter(e => {
                    return e.markAsRead > 0
                })
            }
            return []
        },

       
    }

}
</script>

<style scoped>
    table tr {
        border-bottom: 1px solid #aaa;
    }

    .tdPad{
        padding-bottom: 7px
    }

    #xButt{
        background-color: transparent !important;
        position: fixed;
        font-size: 2rem !important;
        right: 10px;
        z-index: 3
    }

  
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }

</style>